import bus from "../bus";
import { playerEvents } from "./events";

export default function abstractPlayer(el, props) {
  bus.on(playerEvents.RENDER, onRender);
  const audio = el.querySelector("audio");
  const source = audio.querySelector("source");
  document.body.addEventListener("click", onClick);

  let previousArgs = {};

  function onClick() {
    audio.load();
    document.body.removeEventListener("click", onClick);
  }

  function onRender(args) {
    const { key, sourceURL } = args;
    if (sourceURL === "") {
      return;
    }
    if (key !== previousArgs.key) {
      destroy(previousArgs);
      window.getComputedStyle(audio); // Force a render without waiting a cycle
      update(args);
      create(args);
    } else {
      update(args);
    }
    previousArgs = args;
  }

  function create({ onCreate }) {
    if (onCreate) {
      onCreate({ audio, source });
    }
  }

  function update({ sourceURL, title }) {
    if (title !== previousArgs.title) {
      audio.setAttribute("title", title);
    }
    if (sourceURL !== previousArgs.sourceURL) {
      source.setAttribute("src", sourceURL);
    }
  }

  function destroy({ onDestroy }) {
    if (onDestroy) {
      onDestroy({ audio, source });
    }
  }
}
